module.exports = __webpack_public_path__ + "img/posts.1437eddf.svg";